import { render, staticRenderFns } from "./PalletRackSection.vue?vue&type=template&id=5b2cc237"
import script from "./PalletRackSection.vue?vue&type=script&lang=js"
export * from "./PalletRackSection.vue?vue&type=script&lang=js"
import style0 from "./PalletRackSection.vue?vue&type=style&index=0&id=5b2cc237&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports